export const meta = {
  id: 4,
  title: "Selected for Amazon ML Summer School 2026",
  date: "July 2026",
  readTime: "2 min read",
  coverImage: "/blog-images/amazon_ml_summer_school_real.png",
  tags: ["Amazon", "Machine Learning", "Achievement"],
  excerpt: "Thrilled to be among the 3,000 selected for the Amazon ML Summer School 2026 out of 134,000 applicants!",
};

export const content = `
I am absolutely thrilled and humbled to share that I have been selected for the **Amazon ML Summer School (MLSS) 2026**! 🎉

The journey to get here was incredibly competitive and rigorous. To put things into perspective:
- Over **134,000+ candidates** applied for the program.
- Roughly **31,000+ candidates** made it through to the challenging selection round.
- Ultimately, only **3,000 candidates** were selected for the final cohort.

To be part of this exclusive top ~2.2% is a tremendous honor and a massive validation of the hard work I've poured into Machine Learning and AI. 

I am super excited to dive deep into advanced ML concepts, learn directly from top scientists at Amazon, and interact with some of the brightest minds in the country. A huge thank you to the Amazon ML Summer School team for this phenomenal opportunity!

Looking forward to making the absolute most out of these sessions! 🚀

---

![Amazon ML Summer School Acceptance](/blog-images/amzn_mlss26.png)

#Amazon #MachineLearning #AI #AmazonMLSummerSchool #MLSS2026 #Achievement #DeepLearning
`;
